import React from 'react'

import PopoverFooter from './PopoverFooter'

export const Group = ({
	children,
	isDisabledApply,
	onRemove,
	...props
}: {
	children: React.ReactNode
	isDisabledApply: boolean
	onRemove?(): void
	onCancel?(): void
} & React.HTMLAttributes<HTMLFormElement>) => (
	<form className='flex flex-col' {...props}>
		{children}
		<PopoverFooter isDisabledApply={isDisabledApply} onRemove={onRemove} />
	</form>
)
